import area from '@/assets/js/area.js';
export default {
  data() {
    return {
      // addressValue: '',
      showAreaPicker: false,
      areaList: area,
      addressInfo: {}
    };
  },
  methods: {
    setAdd(valArray) {
      const location = {
        districtCode: valArray[1].code,
        city: valArray[1].name,
        province: valArray[0].name
      };
      this.addressInfo = location;
      this.showAreaPicker = false;
      this.saveAddress();
    },
    handleCancel() {
      this.showAreaPicker = false;
    },
    saveAddress() {}
  }
};
